import React, { useState } from "react";

import Button from "@Components/Button";
import Grid from "@Components/Grid";
import TextArea from "@Components/Inputs/TextArea";
import TextField from "@Components/Inputs/TextField";
import { useSendFeedback } from "@Hooks/useFeedback";

import styles from "./Feedback.module.scss";
export interface FeedbackData {
  subject: string;
  message: string;
}

const Feedback: React.FC = () => {
  const [formData, setFormData] = useState<FeedbackData>({
    subject: "",
    message: "",
  });
  const { send, loading } = useSendFeedback();

  const [submitted, setSubmitted] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await send(formData);
    setSubmitted(true);
    setFormData({ subject: "", message: "" });
  };
  return (
    <div className={styles.root}>
      <h2 className={styles.title}>Feedback</h2>
      <p>
        Web Finance Direct is here to help. Send us your feedback or feature
        requests.
      </p>
      {submitted ? (
        <Grid container>
          <Grid xs={12}>
            <h3>Thank you for your submission!</h3>
          </Grid>
          <Grid xs={12}>
            <p>
              We&apos;ve received your message and will get back to you soon.
            </p>
          </Grid>
          <Grid xs={4}>
            <Button onClick={() => setSubmitted(false)}>
              Send Another Message
            </Button>
          </Grid>
        </Grid>
      ) : (
        <form id="feedback-form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid xs={5}>
              <TextField
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, subject: e.target.value }))
                }
                placeholder="Subject"
                value={formData?.subject ?? ""}
                name="subject"
                id="subject"
                type="text"
                required
              />
            </Grid>

            <Grid xs={10}>
              <TextArea
                containerStyle={{
                  border: "1px solid #ccc",
                  borderRadius: "9px",
                }}
                rows={3}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, message: e.target.value }))
                }
                placeholder="Message"
                value={formData?.message ?? ""}
                name="message"
                id="message"
                required
              />
            </Grid>
            <Grid xs={4}>
              <Button type="submit" disabled={loading}>
                {loading ? "Sending..." : "Submit"}
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </div>
  );
};

export default Feedback;
